import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManagementAutomationComponent } from './management-automation.component';
import { ProcessAutomationModule } from '../process-automation/process-automation.module';
import { SharedAdministrationModule } from '../shared-administration/shared-administration.module';
import { ManageTitlesComponent } from './manage-titles/manage-titles.component';
import { TimeControlComponent } from './time-control/time-control.component';
import { StagesTimeControlComponent } from './time-control/stages-time-control/stages-time-control.component';
import { TramitStagesComponent } from './time-control/tramit-stages/tramit-stages.component';
import { StageDetailViewComponent } from './time-control/tramit-stages/stage-detail-view/stage-detail-view.component';
import { ManageDocumentsComponent } from './manage-documents/manage-documents.component';
import { TimeSuspensionsComponent } from './time-control/time-suspensions/time-suspensions.component';


@NgModule({
  imports: [
    CommonModule,
    ProcessAutomationModule,
    SharedAdministrationModule
  ],
  declarations: [ManagementAutomationComponent, ManageTitlesComponent,ManageDocumentsComponent, StagesTimeControlComponent, TimeControlComponent, TramitStagesComponent, StageDetailViewComponent, TimeSuspensionsComponent]
})
export class ManagementAutomationModule { }



// WEBPACK FOOTER //
// ./src/app/administration/management-automation/management-automation.module.ts